import { redirect } from "react-router-dom";
import { fetchMailTemplateConfig } from "../utils/http/mail-template-configs";
import {
  fetchMailTemplateChangeHistory,
  fetchMailTemplates,
  fetchMailTemplateSends,
} from "../utils/http/mail-templates";
import { queryClient } from "../utils/http/queryClient";
import { applyCustomerFromQuery } from "./customer-override";

export async function loader({ params, request }: { params: any; request: Request }): Promise<any> {
  // Honour a `?customer=` override before fetching any company-scoped data.
  await applyCustomerFromQuery(request);

  const { language, event, action, target } = params;
  const { version, automation, ...allExceptVersionAndAutomation } = params;

  const templates = await queryClient.fetchQuery({
    queryKey: ["mailTemplates", allExceptVersionAndAutomation],
    queryFn: ({ signal }) => fetchMailTemplates({ signal, mailTemplatePath: allExceptVersionAndAutomation }),
  });

  // Check if the version which is requested actually exists. If not, redirect to the live version.
  const template = templates.find(
    (mt: any) => mt.event === event && mt.action === action && mt.target === target && mt.version === version
  );
  if (!template && version === "draft") {
    return redirect(`/mail-templates/${language}/${automation}/${event}/${action}/${target}/live`);
  }

  await queryClient.fetchQuery({
    queryKey: ["mailTemplates", "configs", { event, action, target }],
    queryFn: ({ signal }) => fetchMailTemplateConfig({ signal, mailTemplatePath: allExceptVersionAndAutomation }),
  });

  queryClient.fetchQuery({
    queryKey: ["mailTemplates", "sends"],
    queryFn: ({ signal }) => fetchMailTemplateSends({ signal }),
  });

  return templates;
}

export async function loaderChangeHistory({ request }: { params: any; request: Request }): Promise<any> {
  // Honour a `?customer=` override before fetching any company-scoped data.
  await applyCustomerFromQuery(request);

  const changeHistory = await queryClient.fetchQuery({
    queryKey: ["changeHistory"],
    queryFn: ({ signal }) => fetchMailTemplateChangeHistory({ signal }),
  });

  return changeHistory;
}
